namespace('IO.Views.IccPolicies', function (exports) {
  'use strict';
  exports.Show = IO.Views.IccPolicies.New;
});
